var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook36X36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.46042C0.638672 6.11855 0.638672 8.29696 0.638672 12.6538V24.7414C0.638672 29.0982 0.638672 31.2766 1.5 32.9347C2.22583 34.332 3.36513 35.4713 4.76242 36.1971C6.42055 37.0585 8.59896 37.0585 12.9558 37.0585H25.0434C29.4002 37.0585 31.5786 37.0585 33.2367 36.1971C34.634 35.4713 35.7733 34.332 36.4991 32.9347C37.3605 31.2766 37.3605 29.0982 37.3605 24.7414V12.6538C37.3605 8.29696 37.3605 6.11855 36.4991 4.46042C35.7733 3.06313 34.634 1.92383 33.2367 1.198C31.5786 0.33667 29.4002 0.33667 25.0434 0.33667H12.9558C8.59896 0.33667 6.42055 0.33667 4.76242 1.198C3.36513 1.92383 2.22583 3.06313 1.5 4.46042ZM26.956 18.6975L26.1399 23.7978H22.0597V37.0584H15.9394V23.7978H11.3492V18.6975H15.9394V14.6173C15.9394 10.0271 18.8976 7.47696 23.0798 7.47696C24.4058 7.47696 25.8339 7.68097 27.16 7.88498V12.5772H24.8139C22.5698 12.5772 22.0597 13.6993 22.0597 15.1273V18.6975H26.956Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook36X36);
export default __webpack_public_path__ + "static/media/Facebook36x36.90269671d4112d450cab3dc20fabeae4.svg";
export { ForwardRef as ReactComponent };